import React from 'react';
import { Grid, Box, Link } from '@mui/material';
import { navigationButtons } from './navigationButtons';
import ResponsiveButton from './ResponsiveButton';
import { sxHeader } from './styles';

const HeaderLeft = ({ pageConfiguration, history, screenSize }) => {
  const logoSx =
    pageConfiguration.id === 2 && screenSize.width < 460
      ? sxHeader.logoGit
      : sxHeader.logo;

  const navButtons = navigationButtons(pageConfiguration, history).filter(
    btn => btn.show
  );

  return (
    <Grid
      item
      xs={8}
      container
      alignItems="center"
      wrap="nowrap"
      sx={{
        overflow: 'hidden',
        minWidth: 0,
      }}
    >
      <Link href="/" sx={{ display: 'inline-flex' }}>
        <Box
          component="img"
          src={pageConfiguration.site_logos.principal}
          alt="logo"
          sx={logoSx}
        />
      </Link>

      {navButtons.map((btn, index) => {
        return (
          <ResponsiveButton
            key={index}
            type={btn.type}
            label={btn.label}
            logoSrc={btn.logoSrc}
            alt={btn.alt}
            href={btn.href}
            target={btn.target}
            onClick={btn.onClick}
            logoSx={btn.logoSx}
          />
        );
      })}
    </Grid>
  );
};

export default HeaderLeft;
